<template lang="pug">
v-app
  v-alert.alert--global(:type='CR.show.alert.type', :value='CR.show.alert.active', transition="slide-y-reverse-transition", dismissible)
    | {{ CR.show.alert.message }}

  router-view
</template>

<script>
  import Avatar from 'vue-avatar'
  import tools from './assets/tools.js'
  import globalSettings from './assets/global-settings.js'
  import axios from '../node_modules/axios/dist/axios.js'

  export default {
    components: {
      Avatar
    },
    data () {
      return {
        alert: true,
        CR: {
          show: globalSettings.show,
          authorization: globalSettings.authorization,
          trigger: {
            signOut: () => {
              tools.signOut({
                success: () => {
                  this.$router.push({
                    name: 'MagicSignIn'
                  })
                }
              })
            }
          }
        }
      }
    },
    created () {
      var component = this

      tools.alert = function (options) {
        options = options || {}
        options.duration = options.duration || 5000

        if (options.type === 'error') {
          options.message = options.message || 'We\'re sorry, but something went wrong.'
        }

        if (options.message && options.type) {
          component.CR.show.alert.active = true
          component.CR.show.alert.type = options.type
          component.CR.show.alert.message = options.message

          clearTimeout(component.CR.show.alert.timer)
          component.CR.show.alert.timer = setTimeout(function () {
            component.CR.show.alert.active = false
          }, options.duration)
        } else {
          console.warn('### tools.alert() did not trigger due to missing message/type. ###')
        }

        if (options.errorResponse) {
          console.error('errorResponse', options.errorResponse)
        }
      }

      if (window.localStorage.prolific_authorization) {
        axios.defaults.headers.common['Authorization'] = window.localStorage.prolific_authorization
        globalSettings.authorization.loggedIn = true

        tools.loggedInData({
          success: function (loggedInItem) {
            component.CR.authorization.state = loggedInItem.state
            component.CR.authorization.data = loggedInItem.data
          },
          error: function (errorResponse) {
            tools.alert({
              type: 'error',
              errorResponse: errorResponse
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>

h1 {
  margin-right: 1em;
}
a {
  text-decoration: none;
}
.input-group--textarea .input-group__input {
  border-width: 1px;
}
main.content {
  position: relative;
}

.toolbar--clipped {
  padding-right: 0 !important;
}
.side-drawer {
  z-index: 2;
}

</style>



// WEBPACK FOOTER //
// src/App.vue